import { Card, Col, Form, FormGroup, Label, Input, Button } from "reactstrap";
import { MainContainer } from "../Components/MainContainer";
import { useState } from "react";
import { Api } from "../Services/CohortServices";
import "../Styles/CohortCardsStyle.css"
import { useNavigate } from "react-router-dom";
import { ToasterAdviser } from "../Components/ToasterComponent";
export const CreateUser = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    access_level: "user", // Valor padrão, pode ser "user" ou "admin"
  });
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      //eslint-disable-next-line
      const response = await Api.post("/users", formData);
      setSuccess("Usuário criado com sucesso!");
      setTimeout(() => {
        navigate("/dashboard")
      }, 2000);
    } catch (err) {
      setError("Erro ao criar o usuário. Tente novamente mais tarde.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainContainer>
      <>
        <div className="main-content">
          <div className="mt-1">
            <Col md={10} className="offset-md-1">
              <div style={{ fontWeight: "bold" }}>Criar Usuário</div>
              <Card className="p-3 mt-3">
                <Form onSubmit={handleSubmit}>
                  <FormGroup>
                    <Label for="username">Nome</Label>
                    <Input
                      type="text"
                      id="username"
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                      required
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="email">E-mail</Label>
                    <Input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="access_level">Nível de Acesso</Label>
                    <Input
                      type="select"
                      id="access_level"
                      name="access_level"
                      value={formData.access_level}
                      onChange={handleChange}
                    >
                      <option value="user">Usuário</option>
                      <option value="admin">Administrador</option>
                    </Input>
                  </FormGroup>

                  <Button className="cohort_create_button" type="submit" disabled={loading}>
                    {loading ? "Criando..." : "Criar Usuário"}
                  </Button>
                </Form>
              </Card>

              {/* Toast para sucesso */}
              {(success || error) && (
                <ToasterAdviser
                  type={success ? "success" : "error"}
                  message={success || error}
                  icon={success ? "success" : "error"}
                />
              )}
            </Col>
          </div>
        </div>
      </>
    </MainContainer>
  );
};
